module.exports = __webpack_public_path__ + "static/device_traceability-61b7fff7cdd04d1678c5684d7615223d.jpg";